import type { Comp, GameObj, PosComp } from "kaplay";
import type { ObstacleConfig } from "../config/types";

export interface RampComp extends Comp {
    rampType: string;
    rampConfig: ObstacleConfig;
    spent: boolean;
    lipY(): number;
}

export type Ramp = GameObj<RampComp | PosComp>;

export function ramp(rampType: string, config: ObstacleConfig): RampComp {
    return {
        id: "ramp",
        require: ["pos"],
        rampType,
        rampConfig: config,
        spent: false,
        lipY(this: Ramp) {
            return this.pos.y - (config.lipPx ?? 0);
        },
    };
}
